var path = 'app/scripts/modules/cloudfoundry/loadBalancer/configure/createLoadBalancer.html';
var html = "<v2-modal-wizard heading=\"Create New Load Balancer\">\n  <v2-wizard-page key=\"Location\" label=\"Location\">\n    <ng-include src=\"pages.location\"></ng-include>\n  </v2-wizard-page>\n</v2-modal-wizard>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/loadBalancer/configure/createLoadBalancer.html
// module id = 1626
// module chunks = 0